const CONFIRMED_STATUSES = ["paid_with_cc", "paid_with_bt", "reserved"];
const BANK_TRANSFER_STATUSES = ["paid_with_bt", "reserved"];

export const isPaymentConfirmed = ({ status }) => CONFIRMED_STATUSES.indexOf(status) >= 0;
export const isBankTransferPayment = (status) => BANK_TRANSFER_STATUSES.indexOf(status) >= 0;
